import { getBaseURL, getClient } from '../BLL/clients/HttpClient';
import { ApiEndPoint } from '../BLL/Enums/ApiEndPoint';
import { EligibilityStats } from '../pages/Eligibility/EligibilityTypes';

export const getEligibilityStats = async (
  period?: number | string,
  carrierId?: number
): Promise<EligibilityStats> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const params: any = {};
  if (period) {
    params.period = period;
  }
  if (carrierId) {
    params.carrierId = carrierId;
  }

  const { data } = await client.get<EligibilityStats>('v1/eligibility/stats', {
    params,
  });

  return data;
};
